import { useEffect, useState, useRef } from 'react'
import {CVCPrice} from '../../chain/ma'

import {
    WeiToUnits,
    EtherToWei,
} from '../../ethers/e'
import {useEthers} from '../../ethers'


function Price(cvcReserve, usdtReserve) {
    return usdtReserve.toString() / cvcReserve.toString()
}

function ExpcetPrice(newUsdtReserve, cvcReserve, usdtReserve) {
    cvcReserve = WeiToUnits(cvcReserve)
    usdtReserve = WeiToUnits(usdtReserve)
    
    newUsdtReserve = usdtReserve * 1 + newUsdtReserve * 1
    const newCVC = cvcReserve * usdtReserve / newUsdtReserve
    return newUsdtReserve / newCVC
}
const TYPE = {
    burnedCVC: 0,
    treasuryCVC: 0,
    recentPrice: 0,
    prePrice: 0,
    ExpcetPrice: () => 0
}
export function usePrice() {
    const {getBlockNumber} = useEthers()
    const [price, setPrice] = useState(TYPE)
    const prePrice = useRef(null)
    useEffect(() => {
        async function init() {
            const [cvcReserve, usdtReserve,, treasuryCVC, burnedCVC] = await CVCPrice()
            const _price = Price(cvcReserve, usdtReserve)
            const _prePrice = prePrice.current || _price
            prePrice.current = _price
            // console.log(
            //     lastCvcPrice, " lastCvcPrice"
            // )
            setPrice({
                burnedCVC,
                treasuryCVC: WeiToUnits(treasuryCVC),
                recentPrice: _price,
                prePrice: _prePrice,
                ExpcetPrice: newUsdt => ExpcetPrice(newUsdt, cvcReserve, usdtReserve)
            })
        }
        init()
    }, [getBlockNumber()])
    return {
        prices: price,
    }
}